
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oranges/shop",
      function () {
        return require("private-next-pages/oranges/shop/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/oranges/shop"])
      });
    }
  